import React from 'react';
import Softphone from '../Softphone';
import PhoneDirectory from '../PhoneDirectory';
import { PBXContent } from '../../../pages/ems/PBXAdminPage';
import { Settings2, Phone } from 'lucide-react';

export function PhoneTab({ exerciseId, canManageExercise, isAdmin, hasRole, showPhoneSystem, setShowPhoneSystem }) {
  return (
    <div className="rounded-xl overflow-hidden border min-h-[560px] bg-card">
      {(canManageExercise || isAdmin) && (
        <div className="flex items-center justify-end gap-2 p-3 border-b">
          <button
            onClick={() => setShowPhoneSystem(!showPhoneSystem)}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
              showPhoneSystem ? 'bg-primary/10 text-primary border border-primary/30' : 'bg-muted text-muted-foreground border border-border hover:text-foreground'
            }`}
            data-testid="phone-system-toggle"
          >
            <Settings2 className="w-3.5 h-3.5" />
            {showPhoneSystem ? 'Hide' : 'Show'} Phone System
          </button>
        </div>
      )}

      {showPhoneSystem && (canManageExercise || isAdmin) ? (
        <div className="p-4">
          <PBXContent exerciseId={exerciseId} />
        </div>
      ) : hasRole(['participant']) ? (
        <div className="p-6 space-y-5">
          <div className="flex items-center gap-3 pb-4 border-b">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center">
                <Phone className="w-4 h-4 text-primary" />
              </div>
              <div>
                <h2 className="font-bold text-base text-foreground">External Contacts</h2>
                <p className="text-xs text-muted-foreground">Exercise phone directory</p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-muted/30 rounded-xl border p-4">
              <Softphone />
            </div>
            <div className="min-h-[400px]">
              <PhoneDirectory exerciseId={exerciseId} />
            </div>
          </div>
        </div>
      ) : (
        <div className="flex h-full min-h-[560px]">
          <div className="w-80 flex-shrink-0 border-r p-5 overflow-y-auto">
            <Softphone />
          </div>
          <div className="flex-1 p-5 overflow-y-auto">
            <PhoneDirectory exerciseId={exerciseId} />
          </div>
        </div>
      )}
    </div>
  );
}
